(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Banner-Slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AUTOPLAY_DELAY = 5000;
    const TRANSITION_DURATION = 450;
    const TRANSITION_SAFETY_DELAY = 120;
    const DRAG_CLICK_THRESHOLD = 8;

    const initializeSlider = (root) => {
      if (!root || root.dataset.mfBannerInitialized === 'true') return;

      const track = root.querySelector('.mf-banner-slider__track');
      const viewport = root.querySelector('.mf-banner-slider__viewport');
      const arrows = Array.from(root.querySelectorAll('[data-mf-banner-arrow]'));

      if (!track || !viewport) return;

      /* Remove clones left by a possible Theme Editor reload before counting slides. */
      track
        .querySelectorAll('.mf-banner-slider__slide--clone')
        .forEach((clone) => clone.remove());

      const originalSlides = Array.from(track.children).filter((slide) =>
        slide.classList.contains('mf-banner-slider__slide')
      );

      root.dataset.mfBannerInitialized = 'true';

      if (originalSlides.length <= 1) return;

      const slideCount = originalSlides.length;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      let positionIndex = 1;
      let autoplayTimer = null;
      let transitionTimer = null;
      let isAnimating = false;
      let isDragging = false;
      let didDrag = false;
      let activePointerId = null;
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let baseTranslate = 0;
      let isHorizontalDrag = false;
      let destroyed = false;

      const sanitizeClone = (clone) => {
        clone.classList.add('mf-banner-slider__slide--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-mf-banner-clone', 'true');
        clone.removeAttribute('data-shopify-editor-block');

        clone.querySelectorAll('[id]').forEach((element) => {
          element.removeAttribute('id');
        });

        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });

        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });

        return clone;
      };

      const firstClone = sanitizeClone(originalSlides[0].cloneNode(true));
      const lastClone = sanitizeClone(originalSlides[slideCount - 1].cloneNode(true));

      track.insertBefore(lastClone, originalSlides[0]);
      track.appendChild(firstClone);

      const sliderImages = Array.from(track.querySelectorAll('img'));
      sliderImages.forEach((image) => {
        image.loading = 'eager';
        image.decoding = 'async';
      });

      const getSlideWidth = () => Math.max(1, viewport.getBoundingClientRect().width);

      const setTransition = (enabled) => {
        if (reduceMotion.matches || !enabled) {
          track.style.transition = 'none';
          return;
        }

        track.style.transition = `transform ${TRANSITION_DURATION}ms ease`;
      };

      const renderPosition = (animate = true) => {
        setTransition(animate);
        const translate = -(positionIndex * getSlideWidth());
        track.style.transform = `translate3d(${translate}px, 0, 0)`;
      };

      const clearTransitionTimer = () => {
        if (transitionTimer === null) return;
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
      };

      const clearAutoplay = () => {
        if (autoplayTimer === null) return;
        window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      };

      const normalizeLoopPosition = () => {
        if (positionIndex <= 0) {
          positionIndex = slideCount;
          renderPosition(false);
          void track.offsetWidth;
        } else if (positionIndex >= slideCount + 1) {
          positionIndex = 1;
          renderPosition(false);
          void track.offsetWidth;
        }
      };

      const scheduleAutoplay = () => {
        clearAutoplay();

        if (
          destroyed ||
          reduceMotion.matches ||
          document.hidden ||
          isDragging ||
          isAnimating
        ) {
          return;
        }

        autoplayTimer = window.setTimeout(() => {
          autoplayTimer = null;
          moveBy(1);
        }, AUTOPLAY_DELAY);
      };

      const finishTransition = () => {
        if (!isAnimating) return;

        clearTransitionTimer();
        isAnimating = false;
        normalizeLoopPosition();
        scheduleAutoplay();
      };

      const armTransitionFallback = () => {
        clearTransitionTimer();
        transitionTimer = window.setTimeout(
          finishTransition,
          TRANSITION_DURATION + TRANSITION_SAFETY_DELAY
        );
      };

      const moveToPosition = (nextPosition, animate = true) => {
        if (destroyed || isDragging || isAnimating) return false;

        positionIndex = Math.max(0, Math.min(slideCount + 1, nextPosition));

        if (animate && !reduceMotion.matches) {
          isAnimating = true;
          renderPosition(true);
          armTransitionFallback();
        } else {
          renderPosition(false);
          normalizeLoopPosition();
          scheduleAutoplay();
        }

        return true;
      };

      const moveBy = (direction) => {
        clearAutoplay();

        if (!moveToPosition(positionIndex + direction, true)) {
          scheduleAutoplay();
          return false;
        }

        return true;
      };

      const waitForImages = () => {
        const pending = sliderImages.map((image) => {
          if (image.complete && image.naturalWidth > 0) return Promise.resolve();

          return new Promise((resolve) => {
            let finished = false;

            const finish = () => {
              if (finished) return;
              finished = true;
              resolve();
            };

            image.addEventListener('load', finish, { once: true });
            image.addEventListener('error', finish, { once: true });
            window.setTimeout(finish, 8000);
          });
        });

        return Promise.allSettled(pending);
      };

      const beginDrag = (event) => {
        if (destroyed || isAnimating) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('[data-mf-banner-arrow]')) return;
        if (activePointerId !== null) return;

        isDragging = true;
        didDrag = false;
        isHorizontalDrag = false;
        activePointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        currentX = event.clientX;
        baseTranslate = -(positionIndex * getSlideWidth());

        setTransition(false);
        track.classList.add('is-dragging');
        clearAutoplay();
      };

      const moveDrag = (event) => {
        if (!isDragging || event.pointerId !== activePointerId) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        currentX = event.clientX;

        if (!isHorizontalDrag) {
          if (
            Math.abs(deltaX) > DRAG_CLICK_THRESHOLD &&
            Math.abs(deltaX) > Math.abs(deltaY)
          ) {
            isHorizontalDrag = true;
            didDrag = true;
          }
        }

        if (!isHorizontalDrag) return;

        if (event.cancelable) event.preventDefault();
        track.style.transform = `translate3d(${baseTranslate + deltaX}px, 0, 0)`;
      };

      const finishDrag = (event) => {
        if (!isDragging || event.pointerId !== activePointerId) return;

        const deltaX = currentX - startX;
        const slideThreshold = Math.max(50, getSlideWidth() * 0.12);

        isDragging = false;
        activePointerId = null;
        track.classList.remove('is-dragging');

        if (isHorizontalDrag && deltaX <= -slideThreshold) {
          positionIndex = Math.min(slideCount + 1, positionIndex + 1);
        } else if (isHorizontalDrag && deltaX >= slideThreshold) {
          positionIndex = Math.max(0, positionIndex - 1);
        }

        if (reduceMotion.matches) {
          renderPosition(false);
          normalizeLoopPosition();
          scheduleAutoplay();
        } else {
          isAnimating = true;
          renderPosition(true);
          armTransitionFallback();
        }

        window.setTimeout(() => {
          didDrag = false;
          isHorizontalDrag = false;
        }, 0);
      };

      const handleTransitionEnd = (event) => {
        if (event.target !== track || event.propertyName !== 'transform') return;
        finishTransition();
      };

      const handleClick = (event) => {
        const link = event.target.closest('[data-mf-banner-link]');
        if (!link || !didDrag) return;

        event.preventDefault();
        event.stopPropagation();
      };

      const handleVisibilityChange = () => {
        if (document.hidden) {
          clearAutoplay();
        } else {
          scheduleAutoplay();
        }
      };

      const handleResize = () => {
        if (destroyed || isDragging) return;

        clearTransitionTimer();
        isAnimating = false;
        normalizeLoopPosition();
        renderPosition(false);
        scheduleAutoplay();
      };

      const handleMotionPreferenceChange = () => {
        clearAutoplay();
        clearTransitionTimer();
        isAnimating = false;
        normalizeLoopPosition();
        renderPosition(false);
        scheduleAutoplay();
      };

      track.addEventListener('transitionend', handleTransitionEnd);
      track.addEventListener('pointerdown', beginDrag);
      window.addEventListener('pointermove', moveDrag, { passive: false });
      window.addEventListener('pointerup', finishDrag);
      window.addEventListener('pointercancel', finishDrag);
      root.addEventListener('click', handleClick);
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('resize', handleResize, { passive: true });

      arrows.forEach((arrow) => {
        arrow.disabled = true;
        arrow.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const direction = arrow.dataset.mfBannerArrow === 'prev' ? -1 : 1;
          moveBy(direction);
        });
      });

      if (typeof reduceMotion.addEventListener === 'function') {
        reduceMotion.addEventListener('change', handleMotionPreferenceChange);
      } else if (typeof reduceMotion.addListener === 'function') {
        reduceMotion.addListener(handleMotionPreferenceChange);
      }

      /* Start on the first real slide. Pixel positioning avoids cumulative % drift. */
      renderPosition(false);

      waitForImages().finally(() => {
        if (destroyed) return;

        arrows.forEach((arrow) => {
          arrow.disabled = false;
        });

        renderPosition(false);
        scheduleAutoplay();
      });

      root.mfBannerDestroy = () => {
        destroyed = true;
        clearAutoplay();
        clearTransitionTimer();
        window.removeEventListener('pointermove', moveDrag);
        window.removeEventListener('pointerup', finishDrag);
        window.removeEventListener('pointercancel', finishDrag);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('resize', handleResize);

        if (typeof reduceMotion.removeEventListener === 'function') {
          reduceMotion.removeEventListener('change', handleMotionPreferenceChange);
        } else if (typeof reduceMotion.removeListener === 'function') {
          reduceMotion.removeListener(handleMotionPreferenceChange);
        }
      };
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-mf-banner-slider]').forEach(initializeSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('[data-mf-banner-slider]');
      if (root && typeof root.mfBannerDestroy === 'function') {
        root.mfBannerDestroy();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefit-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBenefitCarousels = (scope = document) => {
      scope.querySelectorAll('[data-mf-benefits-carousel]').forEach((carousel) => {
        if (carousel.dataset.mfBenefitsReady === 'true') return;

        const track = carousel.querySelector('[data-mf-benefits-track]');
        const controls = carousel.querySelector('[data-mf-benefits-controls]');
        const previous = carousel.querySelector('[data-mf-benefits-prev]');
        const next = carousel.querySelector('[data-mf-benefits-next]');

        if (!track || !controls || !previous || !next) return;
        carousel.dataset.mfBenefitsReady = 'true';

        const getStep = () => {
          const card = track.querySelector('.benefit');
          if (!card) return Math.max(track.clientWidth * 0.78, 220);
          const styles = window.getComputedStyle(track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
          return card.getBoundingClientRect().width + gap;
        };

        const update = () => {
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const isMobile = window.matchMedia("(max-width: 749px)").matches;
          const totalCards = track.querySelectorAll(".benefit").length;
          const forceMobileControls = isMobile && totalCards > 2;
          const canScroll = maxScroll > 5 || forceMobileControls;
          controls.hidden = !canScroll;
          previous.disabled = !canScroll || track.scrollLeft <= 5;
          next.disabled = !canScroll || track.scrollLeft >= maxScroll - 5;
        };

        previous.addEventListener('click', () => {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });

        update();
        window.setTimeout(update, 250);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeBenefitCarousels(), { once: true });
    } else {
      initializeBenefitCarousels();
    }

    document.addEventListener('shopify:section:load', (event) => initializeBenefitCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-vitrine"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.lsInitialized === 'true') return;
    root.dataset.lsInitialized = 'true';

    const installments = Number.parseInt(root.dataset.installments, 10) || 10;
    const track = root.querySelector('[data-ls-track]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const arrows = Array.from(root.querySelectorAll('[data-ls-arrow]'));
    const updateArrows = () => {
      if (!track) return;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      arrows.forEach((button) => {
        const isPrev = button.dataset.lsArrow === 'prev';
        button.disabled = isPrev ? track.scrollLeft <= 4 : track.scrollLeft >= maxScroll - 4;
      });
    };

    arrows.forEach((button) => {
      button.addEventListener('click', () => {
        if (!track) return;
        const direction = button.dataset.lsArrow === 'next' ? 1 : -1;
        const card = track.querySelector('[data-ls-card]');
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 16;
        const distance = card ? card.getBoundingClientRect().width + gap : Math.round(track.clientWidth * 0.8);
        track.scrollBy({ left: direction * distance, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
    });
    if (track) {
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
      window.setTimeout(updateArrows, 160);
    }

    const money = (cents) => {
      const value = Number(cents || 0);
      try {
        if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
          return Shopify.formatMoney(value, Shopify.money_format);
        }
      } catch (error) {
        console.debug(error);
      }
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100);
    };

    const setMediaSliderIndex = (slider, nextIndex) => {
      if (!slider) return;
      const trackEl = slider.querySelector('[data-ls-media-track]');
      const slides = Array.from(slider.querySelectorAll('[data-ls-media-slide]'));
      if (!trackEl || slides.length === 0) return;

      const normalizedIndex = ((nextIndex % slides.length) + slides.length) % slides.length;
      slider.dataset.current = String(normalizedIndex);
      trackEl.style.transform = `translate3d(-${normalizedIndex * 100}%, 0, 0)`;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === normalizedIndex));
    };

    const setupProductImageSliders = () => {
      root.querySelectorAll('[data-ls-media-slider]').forEach((slider) => {
        if (slider.dataset.lsMediaInitialized === 'true') return;
        slider.dataset.lsMediaInitialized = 'true';

        const media = slider.closest('[data-ls-media]');
        const trackEl = slider.querySelector('[data-ls-media-track]');
        const slides = Array.from(slider.querySelectorAll('[data-ls-media-slide]'));
        if (!media || !trackEl || slides.length <= 1) return;

        const mobileImages = window.matchMedia('(max-width: 749px)');
        if (!mobileImages.matches) {
          media.classList.remove('is-dragging');
          media.dataset.lsMediaDragged = 'false';
          trackEl.style.transition = 'transform .28s ease';
          return;
        }

        let startX = 0;
        let startY = 0;
        let lastX = 0;
        let activePointerId = null;
        let isDragging = false;

        const clearDragFlag = () => {
          window.setTimeout(() => {
            if (media && document.body.contains(media)) media.dataset.lsMediaDragged = 'false';
          }, 90);
        };

        const endDrag = (event) => {
          if (activePointerId === null) return;
          if (event && event.pointerId !== activePointerId) return;

          const deltaX = lastX - startX;
          const currentIndex = Number.parseInt(slider.dataset.current || '0', 10) || 0;

          if (isDragging) {
            if (deltaX < -42) setMediaSliderIndex(slider, currentIndex + 1);
            else if (deltaX > 42) setMediaSliderIndex(slider, currentIndex - 1);
            else setMediaSliderIndex(slider, currentIndex);
          }

          media.classList.remove('is-dragging');
          try { media.releasePointerCapture?.(activePointerId); } catch (error) { console.debug(error); }
          activePointerId = null;
          isDragging = false;
          clearDragFlag();
        };

        media.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          activePointerId = event.pointerId;
          startX = event.clientX;
          startY = event.clientY;
          lastX = event.clientX;
          isDragging = false;
          media.dataset.lsMediaDragged = 'false';
          try { media.setPointerCapture?.(event.pointerId); } catch (error) { console.debug(error); }
        });

        media.addEventListener('pointermove', (event) => {
          if (activePointerId === null || event.pointerId !== activePointerId) return;

          lastX = event.clientX;
          const deltaX = lastX - startX;
          const deltaY = event.clientY - startY;
          const absX = Math.abs(deltaX);
          const absY = Math.abs(deltaY);

          if (!isDragging && absX > 10 && absX > absY * 1.15) {
            isDragging = true;
            media.classList.add('is-dragging');
            media.dataset.lsMediaDragged = 'true';
          }

          if (!isDragging) return;
          event.preventDefault();
          const currentIndex = Number.parseInt(slider.dataset.current || '0', 10) || 0;
          trackEl.style.transform = `translate3d(calc(-${currentIndex * 100}% + ${deltaX}px), 0, 0)`;
        });

        media.addEventListener('pointerup', endDrag);
        media.addEventListener('pointercancel', endDrag);
        media.addEventListener('lostpointercapture', endDrag);

        media.addEventListener('click', (event) => {
          if (media.dataset.lsMediaDragged !== 'true') return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
      });
    };

    setupProductImageSliders();

    root.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-ls-swatch]');
      if (!swatch) return;
      event.preventDefault();

      const card = swatch.closest('[data-ls-card]');
      if (!card) return;

      card.querySelectorAll('[data-ls-swatch]').forEach((button) => button.classList.remove('is-active'));
      swatch.classList.add('is-active');

      const price = Number(swatch.dataset.price || 0);
      const compare = Number(swatch.dataset.compare || 0);
      const variantId = swatch.dataset.variantId;
      const baseUrl = card.dataset.productUrl;
      const imageUrl = swatch.dataset.image;
      const pixPrice = price - Math.floor(price * 0.10);
      const hasCompare = compare > price && compare > 0;

      const pixElement = card.querySelector('[data-ls-pix-main]');
      const priceElement = card.querySelector('[data-ls-card-price]');
      const installmentElement = card.querySelector('[data-ls-installment-full]');
      const compareLine = card.querySelector('[data-ls-compare-line]');
      const compareElement = card.querySelector('[data-ls-compare]');
      const discountBadge = card.querySelector('.ls-badge');
      const mediaSlider = card.querySelector('[data-ls-media-slider]');

      if (pixElement) pixElement.textContent = money(pixPrice);
      if (priceElement) priceElement.textContent = money(price);
      if (installmentElement) installmentElement.textContent = money(Math.round(price / Math.max(installments, 1)));
      if (compareLine) compareLine.style.display = hasCompare ? '' : 'none';
      if (compareElement && hasCompare) compareElement.textContent = money(compare);
      if (discountBadge) {
        if (hasCompare) {
          const diffPix = Math.max(0, compare - pixPrice);
          const pctPix = Math.round((diffPix * 100) / compare);
          discountBadge.textContent = `${pctPix}% OFF`;
          discountBadge.style.display = '';
        } else {
          discountBadge.style.display = 'none';
        }
      }
      if (imageUrl) {
        const mainImage = card.querySelector('.ls-img--main');
        if (mainImage) {
          mainImage.src = imageUrl;
          mainImage.removeAttribute('srcset');
        }

        if (mediaSlider) {
          const firstSlide = mediaSlider.querySelector('[data-ls-media-slide]');
          if (firstSlide) firstSlide.dataset.imageUrl = imageUrl;
          setMediaSliderIndex(mediaSlider, 0);
        }
      }

      if (baseUrl && variantId) {
        const url = `${baseUrl}?variant=${encodeURIComponent(variantId)}`;
        card.querySelectorAll('[data-ls-link]').forEach((link) => { link.href = url; });
        const detailsButton = card.querySelector('[data-ls-details]');
        if (detailsButton && baseUrl && variantId) detailsButton.href = `${baseUrl}?variant=${encodeURIComponent(variantId)}`;
      }
    });

    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-ls-add]');
      if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

      const variantId = Number(button.dataset.variantId || 0);
      if (!variantId) return;

      const originalText = button.textContent.trim();
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = 'Adicionando...';

      try {
        const cartDrawer = document.querySelector('cart-drawer');
        const sectionIds = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
          ? cartDrawer.getSectionsToRender().map((section) => section.id)
          : ['cart-drawer', 'cart-icon-bubble'];

        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        });

        const state = await response.json();
        if (!response.ok || state.status) {
          throw new Error(state.description || state.message || 'Não foi possível adicionar o produto.');
        }

        button.textContent = 'Adicionado!';
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.setActiveElement(button);
          cartDrawer.renderContents(state);
        }

        document.dispatchEvent(new CustomEvent('modifika:product-added', {
          detail: { source: 'home-vitrine', productVariantId: String(variantId), cartData: state }
        }));
      } catch (error) {
        console.error(error);
        button.textContent = 'Tente novamente';
      } finally {
        window.setTimeout(() => {
          if (!document.body.contains(button)) return;
          button.removeAttribute('aria-busy');
          button.disabled = false;
          button.textContent = originalText;
        }, 1800);
      }
    });
  };

  const observe = (root) => {
    if (!root || root.dataset.lsObserved === 'true') return;
    root.dataset.lsObserved = 'true';

    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      initialize(root);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      initialize(root);
      observer.disconnect();
    }, { rootMargin: '600px 0px' });
    observer.observe(root);
  };

  const scan = (scope = document) => scope.querySelectorAll('[data-ls-vitrine]').forEach(observe);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modifika-conheca"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.mfAboutInitialized === 'true') return;
    root.dataset.mfAboutInitialized = 'true';
    const track = root.querySelector('[data-mf-about-track]');
    const slides = Array.from(root.querySelectorAll('.mf-about-slide'));
    const previousButton = root.querySelector('[data-mf-about-prev]');
    const nextButton = root.querySelector('[data-mf-about-next]');
    const dotsContainer = root.querySelector('[data-mf-about-dots]');
    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayDelay = Number.parseInt(root.dataset.autoplayDelay, 10) || 5000;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!track || slides.length <= 1) {
      if (previousButton) previousButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
      if (dotsContainer) dotsContainer.hidden = true;
      return;
    }
    let index = 0;
    let timer = null;
    const waitForImages = () => {
      const imageElements = Array.from(track.querySelectorAll('img'));
      imageElements.forEach((image) => { image.loading = 'eager'; });
      return Promise.allSettled(imageElements.map((image) => {
        if (image.complete && image.naturalWidth > 0) return Promise.resolve();
        return new Promise((resolve) => {
          const finish = () => resolve();
          image.addEventListener('load', finish, { once: true });
          image.addEventListener('error', finish, { once: true });
          window.setTimeout(finish, 8000);
        });
      }));
    };
    const updateDots = () => {
      if (!dotsContainer) return;
      dotsContainer.querySelectorAll('.mf-about-dot').forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    };
    const goTo = (nextIndex, behavior = 'smooth') => {
      index = (nextIndex + slides.length) % slides.length;
      if (mobileQuery.matches) {
        track.scrollTo({left: slides[index].offsetLeft, behavior: reduceMotion.matches ? 'auto' : behavior});
      } else {
        track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      }
      updateDots();
    };
    const stopAutoplay = () => { if (!timer) return; window.clearInterval(timer); timer = null; };
    const startAutoplay = () => {
      stopAutoplay();
      if (!autoplayEnabled || reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(() => goTo(index + 1), autoplayDelay);
    };
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach((_, dotIndex) => {
        const dot = document.createElement('button');
        dot.className = 'mf-about-dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', `Ir para imagem ${dotIndex + 1}`);
        dot.addEventListener('click', () => { goTo(dotIndex); startAutoplay(); });
        dotsContainer.appendChild(dot);
      });
    }
    previousButton?.addEventListener('click', () => { goTo(index - 1); startAutoplay(); });
    nextButton?.addEventListener('click', () => { goTo(index + 1); startAutoplay(); });
    track.addEventListener('pointerdown', stopAutoplay, {passive:true});
    track.addEventListener('pointerup', startAutoplay, {passive:true});
    const onScroll = () => {
      if (!mobileQuery.matches || !track.clientWidth) return;
      const nextIndex = Math.round(track.scrollLeft / track.clientWidth);
      if (nextIndex !== index && nextIndex >= 0 && nextIndex < slides.length) { index = nextIndex; updateDots(); }
    };
    track.addEventListener('scroll', onScroll, {passive:true});
    const onMediaChange = () => { track.style.transform = ''; goTo(index, 'auto'); startAutoplay(); };
    mobileQuery.addEventListener?.('change', onMediaChange);
    reduceMotion.addEventListener?.('change', startAutoplay);
    const onVisibilityChange = () => document.hidden ? stopAutoplay() : startAutoplay();
    document.addEventListener('visibilitychange', onVisibilityChange);
    root._mfAboutCleanup = () => {
      stopAutoplay();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      mobileQuery.removeEventListener?.('change', onMediaChange);
      reduceMotion.removeEventListener?.('change', startAutoplay);
    };
    if (previousButton) previousButton.disabled = true;
    if (nextButton) nextButton.disabled = true;
    goTo(0, 'auto');
    waitForImages().finally(() => {
      if (previousButton) previousButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
      startAutoplay();
    });
  };
  const observe = (root) => {
    if (!root || root.dataset.mfAboutObserved === 'true') return;
    root.dataset.mfAboutObserved = 'true';
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { initialize(root); return; }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      initialize(root);
      observer.disconnect();
    }, {rootMargin:'500px 0px'});
    observer.observe(root);
  };
  const scan = (scope = document) => scope.querySelectorAll('[data-mf-about]').forEach(observe);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true});
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mf-about]').forEach((root) => root._mfAboutCleanup?.());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modifika-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.mfUgcInitialized === 'true') return;
    root.dataset.mfUgcInitialized = 'true';

    const modal = root.querySelector('[data-mf-ugc-modal]');
    const modalBody = modal ? modal.querySelector('[data-mf-ugc-modal-body]') : null;
    const track = root.querySelector('[data-mf-ugc-track]');

    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const stopVideo = (video) => {
      try {
        video.pause();
        video.currentTime = 0;
      } catch (error) {
        console.debug(error);
      }
    };

    const closeAllVideos = () => {
      root.querySelectorAll('video').forEach(stopVideo);
      if (modal) modal.querySelectorAll('video').forEach(stopVideo);
    };

    const openModal = (templateId) => {
      const template = document.getElementById(templateId);
      if (!(template instanceof HTMLTemplateElement) || !modal || !modalBody) return;

      closeAllVideos();
      modalBody.replaceChildren(template.content.cloneNode(true));
      modal.hidden = false;
      modal.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.classList.add('mf-ugc-modal-open');

      const video = modalBody.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {});
      }
    };

    const closeModal = () => {
      if (!modal || !modalBody) return;
      closeAllVideos();
      modalBody.replaceChildren();
      modal.hidden = true;
      modal.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.classList.remove('mf-ugc-modal-open');
    };

    const moveSlider = (direction) => {
      if (!track) return;
      const card = track.querySelector('.mf-ugc-card');
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 14;
      const distance = card ? card.getBoundingClientRect().width + gap : 280;
      track.scrollBy({
        left: direction * distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    root.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-mf-ugc-close]');
      if (closeButton) {
        event.preventDefault();
        closeModal();
        return;
      }

      const openButton = event.target.closest('.mf-ugc-open');
      const previousButton = event.target.closest('.mf-ugc-arrow--prev');
      const nextButton = event.target.closest('.mf-ugc-arrow--next');

      if (openButton) {
        event.preventDefault();
        openModal(openButton.getAttribute('data-modal-target'));
      }
      if (previousButton) moveSlider(-1);
      if (nextButton) moveSlider(1);
    });

    if (modal) {
      modal.addEventListener('click', (event) => {
        const closeButton = event.target.closest('[data-mf-ugc-close]');
        const clickedOutsideDialog = !event.target.closest('.mf-ugc-modal__dialog');

        if (closeButton || clickedOutsideDialog) {
          event.preventDefault();
          event.stopPropagation();
          closeModal();
        }
      });

      modal.addEventListener('touchend', (event) => {
        const closeButton = event.target.closest('[data-mf-ugc-close]');
        const clickedOutsideDialog = !event.target.closest('.mf-ugc-modal__dialog');

        if (closeButton || clickedOutsideDialog) {
          event.preventDefault();
          event.stopPropagation();
          closeModal();
        }
      }, { passive: false });
    }

    root.addEventListener('touchend', (event) => {
      const closeButton = event.target.closest('[data-mf-ugc-close]');
      if (!closeButton) return;
      event.preventDefault();
      closeModal();
    }, { passive: false });

    const handleEscape = (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    };
    document.addEventListener('keydown', handleEscape);
    root._mfUgcCleanup = () => document.removeEventListener('keydown', handleEscape);
  };

  const observe = (root) => {
    if (!root || root.dataset.mfUgcObserved === 'true') return;
    root.dataset.mfUgcObserved = 'true';

    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      initialize(root);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      initialize(root);
      observer.disconnect();
    }, { rootMargin: '300px 0px' });

    observer.observe(root);
  };

  const scan = (scope = document) => scope.querySelectorAll('.mf-ugc-section').forEach(observe);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.mf-ugc-section').forEach((root) => root._mfUgcCleanup?.());
  });
})();

  } catch(e) { console.error(e); }
})();
})();
